/**
 * Footer Component
 * Reusable footer matching Figma design specifications
 * Features: WHO branding, description, dynamic menu columns from API, responsive design
 */
import React from 'react';
import { Box, Container, Grid, useTheme, Stack } from '@mui/material';
import { Typography } from '@components/wrappers';
// import { useFooterMenu } from '@hooks/useMenu';
// import { MenuItem } from '@services/menu.service';

interface FooterProps {
  /** Optional custom background (overrides gradient) */
  backgroundColor?: string;
  /** Optional padding top/bottom override */
  paddingY?: number | { xs: number; md: number };
}

/**
 * Check if a URL is valid and should render as a link
 * Returns false for null, undefined, empty string, or Drupal's <nolink>
 */
// const isValidUrl = (href: string | null | undefined): boolean => {
//   if (!href) return false;
//   if (href === '') return false;
//   if (href === '<nolink>') return false;
//   if (href === 'route:<nolink>') return false;
//   return true;
// };

/**
 * Check if a URL is external
 */
// const isExternalUrl = (href: string): boolean => {
//   return href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//');
// };

/**
 * Render a menu column (parent item with children)
 * COMMENTED OUT - Menu columns are hidden
 */
// const MenuColumn: React.FC<{
//   menuItem: MenuItem;
//   navigate: (path: string) => void;
// }> = ({ menuItem, navigate }) => {
//   /**
//    * Handle link click - prevent default for internal links and use React Router
//    */
//   const handleLinkClick = (
//     e: React.MouseEvent<HTMLAnchorElement>,
//     href: string,
//     isExternal: boolean
//   ) => {
//     // For external links, let the browser handle it naturally
//     if (isExternal || isExternalUrl(href)) {
//       return; // Don't prevent default - allow normal link behavior
//     }

//     // For internal links, prevent default and use React Router navigation
//     e.preventDefault();
//     navigate(href);
//   };

//   return (
//     <Stack spacing={1.5} alignItems="flex-start">
//       <Typography variant="h6" sx={{ mb: 0.5 }}>
//         {menuItem.title}
//       </Typography>
//       {menuItem.children && menuItem.children.length > 0 && (
//         <>
//           {menuItem.children.map((child) => {
//             // Check if child has a valid URL
//             const hasValidUrl = isValidUrl(child.href);

//             // If no valid URL, render as a non-clickable span
//             if (!hasValidUrl) {
//               return (
//                 <Typography
//                   key={child.key}
//                   component="span"
//                   color="text.secondary"
//                   sx={{
//                     display: 'block',
//                     fontSize: '0.875rem',
//                     cursor: 'default',
//                   }}
//                 >
//                   {child.title}
//                 </Typography>
//               );
//             }

//             const isExternal = child.isExternal || isExternalUrl(child.href);

//             // If valid URL, render as a link with click handler
//             return (
//               <Link
//                 key={child.key}
//                 href={child.href}
//                 onClick={(e) => handleLinkClick(e, child.href, isExternal)}
//                 target={isExternal ? '_blank' : undefined}
//                 rel={isExternal ? 'noopener noreferrer' : undefined}
//                 underline="hover"
//                 color="text.secondary"
//                 sx={{
//                   display: 'block',
//                   fontSize: '0.875rem',
//                   transition: 'color 0.2s ease',
//                   cursor: 'pointer',
//                   '&:hover': {
//                     color: 'primary.main',
//                   },
//                 }}
//               >
//                 {child.title}
//               </Link>
//             );
//           })}
//         </>
//       )}
//     </Stack>
//   );
// };

export const Footer: React.FC<FooterProps> = ({ backgroundColor, paddingY = { xs: 2, md: 5 } }) => {
  const theme = useTheme();

  // const { data: footerMenuItems, isLoading } = useFooterMenu();

  return (
    <Box
      component="footer"
      sx={{
        display: 'none', // Hide footer completely
        backgroundColor: backgroundColor || 'transparent',
        background: backgroundColor || 'transparent',
        py: paddingY,
        borderTop: `1px solid ${theme.palette.divider}`,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Grid
          container
          spacing={{ xs: 3, md: 4 }}
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          {/* WHO Section - Logo and Description in Single Row */}
          <Grid item xs={12}>
            <Stack width="100%" justifyContent="center" alignItems="center">
              {/* Description */}
              <Typography
                variant="body2"
                align="center"
                sx={{
                  lineHeight: 1.8,
                  maxWidth: '800px',
                  width: '100%',
                  opacity: 0.7,
                }}
              >
                A centralised platform that brings together a wide range of artificial intelligence
                tools in one easy-to-use dashboard. Users can access writing, design, automation,
                chatbots, marketing, productivity, and learning tools from a single location.
              </Typography>
            </Stack>
          </Grid>

          {/* Dynamic Menu Columns from API - HIDDEN */}
          {/* {isLoading ? (
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress size={24} />
              </Box>
            </Grid>
          ) : footerMenuItems && footerMenuItems.length > 0 ? (
            footerMenuItems.map((menuItem) => (
              <Grid key={menuItem.key} item xs={12} sm={6} md={4} lg={3} xl={3}>
                <MenuColumn menuItem={menuItem} navigate={navigate} />
              </Grid>
            ))
          ) : (
            // Fallback if API fails or returns no items
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                Footer menu unavailable
              </Typography>
            </Grid>
          )} */}
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
